exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2VZkW{min-height:700px;position:relative}._26uXC{max-width:1080px;margin-left:auto;margin-right:auto;padding-left:12px;padding-right:12px}._3mVzD{border-radius:0}._2miVa{width:400px}._3ucQL{font-weight:700;color:#484848}._1vWZZ{display:table;table-layout:fixed;width:100%}._1Ajz4{padding:0}._2S_9x{margin-bottom:6px}._2kJk3{margin-bottom:12px}._1Am-v{margin-bottom:18px}._3NjoO{margin-bottom:24px}._1GcAt{margin-bottom:48px}._2DKW3{margin-top:6px}._2def6{margin-top:12px}._1CK-X{margin-top:18px}.E6AS2{margin-top:24px}._1JNZj{margin-top:48px}._11hAZ{float:right}._24WgK{border-color:#c4c4c4;background:#fff;color:#484848;margin-bottom:0;border-radius:4px;border:1px solid;text-align:center;vertical-align:middle;font-weight:700;line-height:1.43;white-space:normal;cursor:pointer;width:100%;padding:5px 21px}._3XOl_{font-size:16px;color:#767676;font-weight:400}._1yYHK{font-size:18px;color:#767676}._24WgK:focus,._24WgK:hover{border-color:#aaa;color:#484848;text-decoration:none}._2d6J8{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}._2d6J8:active,._2d6J8:active:focus,._2d6J8:active:hover,._2d6J8:focus,._2d6J8:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}._3vr87{position:relative;height:1.25em;width:1.25em;margin-right:10px!important;vertical-align:text-bottom}", ""]);

// exports
exports.locals = {
	"Container": "_2VZkW",
	"containerResponsive": "_26uXC",
	"receiptPanel": "_3mVzD",
	"rowWidth": "_2miVa",
	"textBold": "_3ucQL",
	"rowTable": "_1vWZZ",
	"noPadding": "_1Ajz4",
	"space1": "_2S_9x",
	"space2": "_2kJk3",
	"space3": "_1Am-v",
	"space4": "_3NjoO",
	"space5": "_1GcAt",
	"spaceTop1": "_2DKW3",
	"spaceTop2": "_2def6",
	"spaceTop3": "_1CK-X",
	"spaceTop4": "E6AS2",
	"spaceTop5": "_1JNZj",
	"pullRight": "_11hAZ",
	"button": "_24WgK",
	"landingLabel": "_3XOl_",
	"titleText": "_1yYHK",
	"btnPrimaryBorder": "_2d6J8",
	"blockRadioButton": "_3vr87"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/ReportUserForm/ReportUserForm.css
// module id = 2558
// module chunks = 15